<section id="home" class="home">
    <section class="home__banner banner-container hero is-fullheight banner-header-home" aria-label="Montreal Viagens - Maragogi">
        <app-new-header></app-new-header>
        <section id="text" class="home__text">
            <div class="is-fullhd home__text-container">
                <div class="home__text-title">
                    <h1>
                        Seu clube de hospedagem
                    </h1>
                </div>
                <div class="home__text-subtitle">
                    <p>
                        Resorts, Hotéis, Pousadas e várias
                        outras acomodações no Brasil e
                        exterior em 12x sem juros
                    </p>
                </div>
            </div>
        </section>
    </section>
    <section id="plans-simulator" class="home__plans-simulator">
        <app-plans-simulator></app-plans-simulator>
    </section>
    <section id="signature-informations" class="home__signature-informations">
        <app-video-player [title]="signatureInformationsTitle"
                          [subtitle]="signatureInformationsSubtitle"
                          [srcYoutube]="signatureInformationsSrcYoutube"
                          [cards]="signatureInformations"
                          [backgroudImageVideo]="signatureBackgroudImageVideo"
                          [showCards]="true">
        </app-video-player>
    </section>
    <section id="plans-informations" class="home__plans-informations">
        <app-plans-informations></app-plans-informations>
    </section>
    <section id="tips" class="home__tips">
        <app-tips></app-tips>
    </section>
    <section id="hotels-informations" class="home__hotels-informations">
        <app-hotels-informations></app-hotels-informations>
    </section>
    <section id="partner-hotels" class="home__partner-hotels">
        <app-partner-hotels></app-partner-hotels>
    </section>
    <section id="about-us" class="home__about-us">
        <app-video-player [title]="aboutUsTitle"
                          [titleSize]="'2.25rem'"
                          [srcYoutube]="aboutUsSrcYoutube"
                          [backgroudImageVideo]="aboutUsBackgroundImageVideo"
                          [linearGradient]="aboutUsBackgroundLinearGradient"
                          [showButtonMobile]="true"
        >
        </app-video-player>
    </section>
    <section id="footer" class="home__footer">
        <app-new-footer></app-new-footer>
    </section>
</section>
